import { Link } from "react-router-dom";
import { ExternalLink, KeyRound } from "lucide-react";
import { StatusBadge } from "@/components/common/StatusBadge";
import { fdate, mxn } from "@/lib/format";
import { TIPOS_OT } from "@/lib/arrendamiento";

const COLOR = { desembolso: "text-sky-700", pago: "text-emerald-700", opcion: "text-primary", origen: "text-slate-600" };

// Build 3 · Perfil 360: movimientos del arrendamiento con liga al crédito en Cartera.
export function ArrendamientoMovimientos({ credito, testid }) {
  const movs = credito?.movimientos_arrendamiento || [];
  const op = credito?.opcion_terminal;
  return (
    <section className="mb-5" data-testid={testid}>
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <h4 className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-primary">
          <KeyRound className="h-3.5 w-3.5" /> Arrendamiento · {credito.numero_credito} · {credito.estatus}
          {op ? ` · opción terminal: ${TIPOS_OT[op.tipo]}` : ""}
        </h4>
        <Link to={`/sofom/cartera?credito=${credito.id}`} data-testid={`${testid}-liga`}
          className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline">
          Ver crédito en Cartera <ExternalLink className="h-3 w-3" />
        </Link>
      </div>
      <div className="overflow-x-auto rounded-md border border-slate-200">
        <table className="w-full text-left text-xs" data-testid={`${testid}-tabla`}>
          <thead className="bg-slate-50 uppercase tracking-wide text-slate-500">
            <tr><th className="px-2 py-1.5">Fecha</th><th className="px-2 py-1.5">Movimiento</th><th className="px-2 py-1.5 text-right">Monto</th>
              <th className="px-2 py-1.5">Referencia</th><th className="px-2 py-1.5">Estatus</th></tr>
          </thead>
          <tbody>
            {movs.map((m, i) => (
              <tr key={`${m.tipo}-${m.referencia}-${i}`} className="border-t border-slate-100" data-testid={`${testid}-mov-${m.tipo}-${i}`}>
                <td className="px-2 py-1.5">{fdate(m.fecha)}</td>
                <td className={`px-2 py-1.5 font-medium ${COLOR[m.tipo] || ""}`}>
                  {m.concepto}{m.motivo ? <span className="font-normal text-slate-500"> · motivo: {m.motivo}</span> : null}
                </td>
                <td className="px-2 py-1.5 text-right font-mono tabular-nums">{mxn(m.monto)}</td>
                <td className="px-2 py-1.5 font-mono">{m.referencia || "—"}</td>
                <td className="px-2 py-1.5"><StatusBadge value={m.estatus} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
